export default __webpack_public_path__ + "static/media/Transport_icon.a1003bcf.svg";